import { z } from 'zod';
import { Channel } from '.';

export const GrowerProductChannelSchema = {
  metricsUpdated: z.object({
    productCost: z.number().default(0),
    arExpenses: z.number().default(0),
    apExpenses: z.number().default(0),

    units: z.number().default(0),
    weight: z.number().default(0),
    pallets: z.number().default(0),
  }),
  // Bare ping, same contract as SalesOrderChannel.expensesUpdated: data-free on purpose.
  expensesUpdated: z.object({ growerProductId: z.number() }),
} as const;

export const GrowerProductChannel: Channel<number, typeof GrowerProductChannelSchema> = {
  getChannelId: (id) => `growerProduct:${id}`,
  topics: { metricsUpdated: 'metricsUpdated', expensesUpdated: 'expensesUpdated' },
  schemas: GrowerProductChannelSchema,
};
